import moment from "moment-timezone";
import C from "@/utils/constants";

export function useTime() {
  function dateTimeFormat(date: moment.MomentInput | null | undefined) {
    return date ? moment(date).format(C.DATETIME_FORMAT) : "";
  }

  function dateFormat(date: moment.MomentInput | null | undefined) {
    return date ? moment(date).format(C.DATE_FORMAT) : "";
  }

  return {
    dateTimeFormat,
    dateFormat,
  };
}

export default useTime;
